import React from 'react';

const PapoDeBalcao: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.0107422L17.4354 8.00003H19.9242C22.2011 8.00003 24.0019 9.88985 24 12.1643V24L0 24V12.1619C0 9.88949 1.80052 8.00002 4.07735 8.00002L10 8.00008V0.0107422ZM12 5.0954V10.0001L4.07735 10C2.95584 10 2 10.9426 2 12.1619V22L22 22V12.1634C22.0011 10.9431 21.0455 10 19.9242 10H16.5646L12 5.0954Z"
      />
    </svg>
  );
};

export default PapoDeBalcao;
